import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import Gmap from './Gmap';
import bowser from 'bowser'
import remodal from 'remodal'
import FixedSidenav from './FixedSidenav';
import changeNavCurrent from './changeNavCurrent';
import matchheight from 'jquery-match-height';

if(bowser.msie === true) {
  $('body').addClass('ie');
}else if(bowser.msedge === true){
  $('body').addClass('edge');
}else if(bowser.firefox === true){
  $('body').addClass('ff');
}else if(bowser.tablet === true){
  $('body').addClass('tablet');
}
if(bowser.mobile === true){
  $('body').addClass('device--mobile');
  if(bowser.android === true) {
    $('body').addClass('device--mobile--android');
  }
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
  os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
  os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
  os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
  os = "win7";
}else{
  os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
// const nav_clone = $('.gnav').clone();
// $('#scroller').append(nav_clone.find('ul'));
//
$('.spnavi .menu-item-has-children > a').after('<span class="menu-toggle js-menu-toggle">+</i></span>');
$('.spnavi .menu-item-has-children .sub-menu a').prepend('- &nbsp;')
$('#scroller > ul > li .js-menu-toggle').on('click',function(){
	target = $(this).next('.sub-menu');
	if(target.css('display') !== 'block'){
		target.slideDown('200');
		$(this).addClass('active').text('-');
	}else{
		target.slideUp('200');
		$(this).removeClass('active').text('+');
	}
});
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop',100,400);
totop.exec();
/* gmap
----------------------- */
if($('#access_map').length > 0){
	$(window).on('load',function(){
		let gmap = new Gmap(
				'access_map',
				[{"stylers": [{"hue": "#84c8ff"},{"lightness": 22}],"elementType": "all","featureType": "all"}],
				{lat:35.019923, lng:135.773959},
				{lat:35.019923, lng:135.773959},
				{zoom:16,icon:MAPPIN,title:'map'}
			);
		gmap.exec();
	});
}

(function($) {
$(function(){
	//Pdf
	$('.js--link_icon[href$=pdf]').addClass('js--link_icon-pdf').attr({target:"_blank"});
	//Excel
	$('.js--link_icon[href$=xls],.js--link_icon[href$=xlsx],.js--link_icon[href$=xlsm]').addClass('js--link_icon-xls').attr({target:"_blank"});
	//Word
	$('.js--link_icon[href$=doc],.js--link_icon[href$=docx]').addClass('js--link_icon-docx').attr({target:"_blank"});
	//PowerPoint
	$('.js--link_icon[href$=pptx],.js--link_icon[href$=pptm],.js--link_icon[href$=ppt]').addClass('js--link_icon-pptx').attr({target:"_blank"});
	//外部リンク
	$('.js--link_icon[href^=http]:not([href*="'+location.hostname+'"],[href$=pdf],[href$=xls],[href$=xlsx],[href$=xlsm],[href$=doc],[href$=docx],[href$=pptx],[href$=pptm],[href$=ppt])').addClass('js--link_icon-ext').attr({target:"_blank"});
});
})(jQuery);


(function($) {
$(function(){
	$('.list li').each(function(){
		let txt = $(this).html();
		txt = txt.replace(/Fukuma S/g,'<u>Fukuma S</u>');
		txt = txt.replace(/Shingo Fukuma/g,'<u>Shingo Fukuma</u>');
		txt = txt.replace(/SHINGO FUKUMA/g,'<u>SHINGO FUKUMA</u>');
		txt = txt.replace(/福間 真悟/g,'<u>福間 真悟</u>');
		txt = txt.replace(/福間真悟/g,'<u>福間真悟</u>');
		txt = txt.replace(/池之上辰義/g,'<u>池之上辰義</u>');
		txt = txt.replace(/山田ゆかり/g,'<u>山田ゆかり</u>');
		txt = txt.replace(/齋藤良行/g,'<u>齋藤良行</u>');
		txt = txt.replace(/池之上 辰義/g,'<u>池之上 辰義</u>');
		txt = txt.replace(/山田 ゆかり/g,'<u>山田 ゆかり</u>');
		txt = txt.replace(/齋藤 良行/g,'<u>齋藤 良行</u>');
		txt = txt.replace(/Ikenoue T/g,'<u>Ikenoue T</u>');
		txt = txt.replace(/Yamada Y/g,'<u>Yamada Y</u>');
		txt = txt.replace(/Saito Y/g,'<u>Saito Y</u>');
		$(this).html(txt);
	});
});
})(jQuery);

$(window).on('load',function(){
	let my_remodal = require('./my_remodal');
	my_remodal();

	const fixednav = new FixedSidenav(0,$('.js-fixed_sidemenu').length);
	fixednav.exec();

	const change_nav_current = new changeNavCurrent();
	change_nav_current.exec();
});
let target;
$('.gnav > ul > li').on('mouseenter',function(){
	target = $(this).find('.sub-menu');
	if(target.css('display') !== 'block'){
		target.slideDown('200');
	}
}).on('mouseleave',function(){
	target = $(this).find('.sub-menu');
	if(target.css('display') == 'block'){
		target.slideUp('200');
	}
});

$('.topics-list-item-title').each(function(){
	let This = $(this);
	This.on('click',function(){
		if(This.hasClass('active')){
			This.next('.topics-list-item-col').slideUp(600);
			This.removeClass('active');
		}else{
			This.next('.topics-list-item-col').slideDown(600);
			This.addClass('active');
		}
	});
});

$('.publications .btn.btn-mod-white').on('click',function(){
	let This = $(this);
	if(This.hasClass('active')) {
		$('.paper-info-wrap.next').slideUp(600);
		This.removeClass('active');
	}else{
		$('.paper-info-wrap.next').slideDown(600);
		This.addClass('active');
	}
});

$(window).on('load',function(){
	if($(window).width() > 768) {
		max_height();
	}
});

function max_height() {
	$('.team-item').each(function(){
		let maxLength = 0;
		let three_column = $(this).find('._3col');
		$(three_column).each(function(){
			let three_column_item = $(this).find('._js-matchheight');
			let three_column_length = $(three_column_item).length;
			for(var i=0; i < three_column_length; i++) {
				$(three_column_item).eq(i).addClass('number_' + i);
				if(i > maxLength) {
					maxLength = i;
				}
			}
		});
		for(var i_2=0; i_2 <= maxLength; i_2++) {
			let maxHeight = 0;
			$('._js-matchheight' + '.number_' + i_2).each(function(){
				if($(this).height() > maxHeight) {
					maxHeight = $(this).height();
				}
			});
			$('._js-matchheight' + '.number_' + i_2).height(maxHeight);
		}
	});
}

if($('body').hasClass('contact') ){
	const mw_form = $('.mw_wp_form');
	if($(mw_form).hasClass('mw_wp_form_confirm') || $(mw_form).hasClass('mw_wp_form_complete')) {
		$('.inner_links').css('display','none');
		$('.js-ideal').css('display','none');
	}
}


/*$(window).on('load',function(){

	const Twitter = $('.twitter-api');

	let time = 0;

	Twitter.on('touchstart',function(e){
		if(e.originalEvent.touches.length == '2'){
			Twitter.addClass('_available-scroll');
		}
	});

	Twitter.on('touchmove',function(e){
		if(e.originalEvent.touches.length == '2'){
			Twitter.addClass('_available-scroll');
			time = 3000;
		}
	});

	setTimeout(Twitter_Sp_End(),time);

	function Twitter_Sp_End() {
		if(Twitter.hasClass('_available-scroll')) {
			Twitter.removeClass('_available-scroll');
		}
	}

});*/


if ( $('.mw_wp_form .error')[0] ) {
	var errorEl = $('.mw_wp_form .error').eq(0);
	var position = errorEl.parent().offset().top;

	$('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
}

const Body = $('body');
const Gnav = $('.gnav > ul > li');
if(Body.hasClass('archive') || Body.hasClass('single-post')) {
	Gnav.each(function(){
		if( $(this).find('a').text() =='NEWS') {
			$(this).addClass('current_page_item');
		}
	});
}

function Dont_tel(){
	let dont_tel = $('.js-dont_tel');
	dont_tel.each(function(){
		let dont_tel_text = $(this).text();
		$(this).after(dont_tel_text);
		$(this).remove();
	});
}
$(window).on('load',function(){
	Dont_tel();
});

if( $('body').hasClass('single') || $('body').hasClass('archive') || $('body').hasClass('news') ) {
	$('.menu-item-36').addClass('current_page_item');
}

// publicページ

const public_contents = $('.public-contents');
const public_tab = $('.public-tab-item');

$('#cat01').on('click',function() {
	$(public_tab).removeClass('_active');
	$(this).addClass('_active');
	$(public_contents).removeClass('_active');
	$('#cat01_contents').addClass('_active');
});
$('#cat02').on('click',function() {
	$(public_tab).removeClass('_active');
	$(this).addClass('_active');
	$(public_contents).removeClass('_active');
	$('#cat02_contents').addClass('_active');
});
$('#cat03').on('click',function() {
	$(public_tab).removeClass('_active');
	$(this).addClass('_active');
	$(public_contents).removeClass('_active');
	$('#cat03_contents').addClass('_active');
});
$('#cat04').on('click',function() {
	$(public_tab).removeClass('_active');
	$(this).addClass('_active');
	$(public_contents).removeClass('_active');
	$('#cat04_contents').addClass('_active');
});
$('#cat05').on('click',function() {
	$(public_tab).removeClass('_active');
	$(this).addClass('_active');
	$(public_contents).removeClass('_active');
	$('#cat05_contents').addClass('_active');
});
$('#cat06').on('click',function() {
	$(public_tab).removeClass('_active');
	$(this).addClass('_active');
	$(public_contents).removeClass('_active');
	$('#cat06_contents').addClass('_active');
});



// WEBPACK FOOTER //
// ./dev/js/scripts/main.js